import {  Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import macro from '../../../../../assets/images/bundle/macro.svg';
import NoocoLogo from '../../../../../assets/images/favicon.png';
import { Popover } from 'antd';
import styled from 'styled-components';
import { Input, ModalNooco } from '@photocarbone/nooco-ui';
import './bundleCardHeader.scss';
import { RoundElement } from '../../../../projects/HomeProject/ProjectsList/ProjectCard/RoundElement';
import { BundleLineDTO } from '../../../../models/BundleDTO';
import dayjs from 'dayjs';
import { updateBundleValue } from '../../../../../actions/bundle';
import { useDispatch, useSelector } from 'react-redux';
import { StateDTO } from '../../../../models/GeneralDTO';
import {
  useCreateBundle,
  useDeleteBundle,
  usePatchBundle,
} from '../../../../../hooks/useQuery/bundle';
import formatNumber from '../../../../services/mathematics/formatNumber';
import InfoIcon from '@material-ui/icons/Info';
import { useTranslation } from 'react-i18next';
import { SEARCH_GROUP_OPTION_VALUES } from '../../../../globalVariable/searchGroupType';
import { Amplify } from 'aws-amplify';
import { basicConfigAmplify } from '../../../../..';
import { downloadData } from 'aws-amplify/storage';
import convert from 'xml-js';
import config from '../../../../../config';

const CommentIcon = ({ isCommentFilled }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      style={{ position: 'absolute', top: '20%', right: '-15px' }}
    >
      <g clipPath="url(#clip0_615_3776)">
        <path
          className={`backgroundSvg ${isCommentFilled ? 'filled' : ''}`}
          d="M25.4036 6.60367C24.187 5.383 22.7432 4.41235 21.1536 3.74653C19.5232 3.06153 17.772 2.71055 16.0036 2.71439H15.9429C12.3821 2.72867 9.05 4.12153 6.55714 6.63939C4.06071 9.15724 2.7 12.5001 2.71428 16.0608C2.725 18.2144 3.26071 20.3537 4.26786 22.243L4.42857 22.543V27.5715H9.45714L9.75714 27.7322C11.6464 28.7394 13.7857 29.2751 15.9393 29.2858H16C19.5357 29.2858 22.8571 27.9215 25.3607 25.443C27.875 22.9501 29.2714 19.618 29.2929 16.0608C29.3 14.2537 28.9536 12.5037 28.2607 10.8537C27.5945 9.26432 26.6239 7.82056 25.4036 6.60367ZM8.85714 17.7144C8.40854 17.7052 7.98141 17.5206 7.66739 17.2001C7.35337 16.8796 7.17749 16.4488 7.17749 16.0001C7.17749 15.5514 7.35337 15.1206 7.66739 14.8001C7.98141 14.4796 8.40854 14.295 8.85714 14.2858C9.30574 14.295 9.73287 14.4796 10.0469 14.8001C10.3609 15.1206 10.5368 15.5514 10.5368 16.0001C10.5368 16.4488 10.3609 16.8796 10.0469 17.2001C9.73287 17.5206 9.30574 17.7052 8.85714 17.7144ZM16 17.7144C15.5514 17.7052 15.1243 17.5206 14.8102 17.2001C14.4962 16.8796 14.3203 16.4488 14.3203 16.0001C14.3203 15.5514 14.4962 15.1206 14.8102 14.8001C15.1243 14.4796 15.5514 14.295 16 14.2858C16.4486 14.295 16.8757 14.4796 17.1897 14.8001C17.5038 15.1206 17.6796 15.5514 17.6796 16.0001C17.6796 16.4488 17.5038 16.8796 17.1897 17.2001C16.8757 17.5206 16.4486 17.7052 16 17.7144ZM23.1429 17.7144C22.6943 17.7052 22.2671 17.5206 21.9531 17.2001C21.6391 16.8796 21.4632 16.4488 21.4632 16.0001C21.4632 15.5514 21.6391 15.1206 21.9531 14.8001C22.2671 14.4796 22.6943 14.295 23.1429 14.2858C23.5915 14.295 24.0186 14.4796 24.3326 14.8001C24.6466 15.1206 24.8225 15.5514 24.8225 16.0001C24.8225 16.4488 24.6466 16.8796 24.3326 17.2001C24.0186 17.5206 23.5915 17.7052 23.1429 17.7144Z"
          fill="current"
        />
        <path
          className={`dots ${isCommentFilled ? 'filled' : ''}`}
          d="M21.4286 15.9999C21.4286 16.4546 21.6092 16.8906 21.9307 17.2121C22.2522 17.5336 22.6882 17.7142 23.1429 17.7142C23.5975 17.7142 24.0336 17.5336 24.3551 17.2121C24.6766 16.8906 24.8572 16.4546 24.8572 15.9999C24.8572 15.5453 24.6766 15.1092 24.3551 14.7877C24.0336 14.4663 23.5975 14.2856 23.1429 14.2856C22.6882 14.2856 22.2522 14.4663 21.9307 14.7877C21.6092 15.1092 21.4286 15.5453 21.4286 15.9999ZM7.14288 15.9999C7.14288 16.4546 7.32349 16.8906 7.64499 17.2121C7.96648 17.5336 8.40251 17.7142 8.85717 17.7142C9.31183 17.7142 9.74786 17.5336 10.0694 17.2121C10.3908 16.8906 10.5715 16.4546 10.5715 15.9999C10.5715 15.5453 10.3908 15.1092 10.0694 14.7877C9.74786 14.4663 9.31183 14.2856 8.85717 14.2856C8.40251 14.2856 7.96648 14.4663 7.64499 14.7877C7.32349 15.1092 7.14288 15.5453 7.14288 15.9999Z"
          fill="current"
        />
        <path
          d="M30.7572 9.8C29.95 7.88214 28.7929 6.16071 27.3179 4.68214C25.8532 3.21213 24.1144 2.04365 22.2 1.24286C20.2357 0.417857 18.15 0 16 0H15.9286C13.7643 0.0107143 11.6679 0.439286 9.69645 1.28214C7.79844 2.09115 6.07596 3.2617 4.62502 4.72857C3.16431 6.20357 2.01788 7.91786 1.22502 9.82857C0.403591 11.8071 -0.0106948 13.9107 1.95113e-05 16.075C0.0121383 18.5553 0.598919 20.999 1.71431 23.2143V28.6429C1.71431 29.0786 1.88739 29.4964 2.19549 29.8045C2.50358 30.1126 2.92145 30.2857 3.35716 30.2857H8.78931C11.0046 31.4011 13.4483 31.9879 15.9286 32H16.0036C18.1429 32 20.2179 31.5857 22.1715 30.775C24.0762 29.9838 25.8085 28.8289 27.2715 27.375C28.7465 25.9143 29.9072 24.2071 30.7179 22.3036C31.5607 20.3321 31.9893 18.2357 32 16.0714C32.0107 13.8964 31.5893 11.7857 30.7572 9.8ZM25.3607 25.4429C22.8572 27.9214 19.5357 29.2857 16 29.2857H15.9393C13.7857 29.275 11.6465 28.7393 9.75716 27.7321L9.45716 27.5714H4.42859V22.5429L4.26788 22.2429C3.26073 20.3536 2.72502 18.2143 2.71431 16.0607C2.70002 12.5 4.06073 9.15714 6.55716 6.63929C9.05002 4.12143 12.3822 2.72857 15.9429 2.71429H16.0036C17.7893 2.71429 19.5215 3.06071 21.1536 3.74643C22.7465 4.41429 24.175 5.375 25.4036 6.60357C26.6286 7.82857 27.5929 9.26071 28.2607 10.8536C28.9536 12.5036 29.3 14.2536 29.2929 16.0607C29.2715 19.6179 27.875 22.95 25.3607 25.4429Z"
          fill="current"
        />
        <path
          className={`dots ${isCommentFilled ? 'filled' : ''}`}
          d="M14.2857 15.9999C14.2857 16.4546 14.4663 16.8906 14.7878 17.2121C15.1093 17.5336 15.5453 17.7142 16 17.7142C16.4546 17.7142 16.8907 17.5336 17.2122 17.2121C17.5337 16.8906 17.7143 16.4546 17.7143 15.9999C17.7143 15.5453 17.5337 15.1092 17.2122 14.7877C16.8907 14.4663 16.4546 14.2856 16 14.2856C15.5453 14.2856 15.1093 14.4663 14.7878 14.7877C14.4663 15.1092 14.2857 15.5453 14.2857 15.9999Z"
          fill="current"
        />
      </g>
      <defs>
        <clipPath id="clip0_615_3776">
          <rect width="32" height="32" />
        </clipPath>
      </defs>
    </svg>
  );
};

type BundleCardHeaderProps = {
  style?: any;
  ref?: any;
  measure?: Function;
  details?: boolean;
  setExpanded: Function;
  line: BundleLineDTO;
};

const BundleCardWrapper = styled.div<{ $screen?: string }>`
  border-radius: ${(props) =>
    props.$screen === 'details' ? '15px 15px 0 0' : '15px'};
  margin-bottom: ${(props) => (props.$screen === 'details' ? '0' : '1em')};
`;

const styleNotAllowed = {
  cursor: 'not-allowed',
  filter:
    'invert(9%) sepia(0%) saturate(20%) hue-rotate(21deg) brightness(78%) contrast(140%)',
};

export const getSheetType = (line: BundleLineDTO) => {
  const isBundleSheet = line.type_fiche === "bundle";
  const isConfiguredSheet = line.type_fiche === "FC";
  const isModelingSheet =  line.type_fiche === "custom_user";
  const isSheetOption = line?.id && line?.SheetOption?.length > 0 ? true : false;
  const isModelingPhase = isModelingSheet &&  ((line?.lines && line?.lines[0].modelingEquipmentCarbonWeightForm) || (line?.id && !isSheetOption) ) ? true : false;
  const isModelingEstimate = isModelingSheet && ((line.lines && line?.lines[0].manufacturedRate !== undefined) || isSheetOption) ? true : false;

  return {isBundleSheet, isConfiguredSheet, isModelingSheet, isModelingPhase, isModelingEstimate};
}

export const getXmlFileFromS3 = async (folderSheetId, companyId, xmlId) => {
  Amplify.configure({
    ...basicConfigAmplify,
    Storage: {
      S3: {
        bucket: config.config.BUCKET,
        region: config.cognito.REGION,
      },
    },
  });
  const path = folderSheetId ? `${companyId}/${folderSheetId}/${xmlId}.xml` : `${companyId}/${xmlId}.xml`;
  const { body } = await downloadData({
    key: path,
  }).result;

  const bodyXml = await body.text();
  const fileName =  JSON.parse(convert.xml2json(bodyXml, { compact: true, spaces: 4 })).EPDC?.Name?._text;
  // Créer un Blob avec le contenu XML
  const blob = new Blob([body], { type: 'application/xml' });

  // Créer un File à partir du Blob
  const fileOptions = { type: blob.type }; 
  const newXmlFile = new File([blob], fileName, fileOptions);
  const xmlFileTextFormated = await newXmlFile?.text();

  return {xmlFileTextFormated: xmlFileTextFormated};
};


const BundleCardHeader = ({
  details,
  setExpanded,
  line,
}: BundleCardHeaderProps) => {
  const dispatch = useDispatch();
  const { newBundle, editBundle, folderSheetId, companyId } = useSelector(
    (state: StateDTO) => state.bundle
  );
  const { modeledProductOptions } = useSelector((state: StateDTO) => state.projects);
  const { user } = useSelector((state: StateDTO) => state.projects);
  const [openModal, setOpenModal] = useState<boolean>(false);

  const deleteBundleHook = useDeleteBundle();
  const createBundleHook = useCreateBundle();
  const patchBundleHook = usePatchBundle();

  const { t } = useTranslation();

  const renderLineName = () => {
    if (details) {
      return (
        <div className="name-edit">
          <p className="dark-blue-font" style={{ textAlign: 'left' }}>
  {t('APP.BUNDLECARDHEADER.INDEX.NAME', { defaultValue: 'Nom' })}
</p>
          <Input
            style={{ width: '100%' }}
            defaultValue={line.name}
            onBlur={(e) =>
              !line.id
                ? dispatch(
                    updateBundleValue('newBundle', {
                      ...newBundle,
                      name: e.target.value,
                    })
                  )
                : dispatch(
                    updateBundleValue(
                      'editBundle',
                      editBundle.map((bundle) =>
                        bundle.id === line.id
                          ? { ...bundle, name: e.target.value }
                          : bundle
                      )
                    )
                  )
            }
          />
        </div>
      );
    } else {
      return <p className="dark-blue-font center">{line.name}</p>;
    }
  };

  const renderCommentInput = () => {
    return (
      <div
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
        key={line.id}
      >
        <Input
          disabled={patchBundleHook.isLoading}
          defaultValue={line.comment}
          onBlur={
            line.id
              ? (e) => {
                  patchBundleHook.mutate({
                    id: line.id,
                    comment: e.target.value,
                    folderSheetId: folderSheetId,
                    CompanyId: companyId,
                  });
                }
              : () => {}
          }
          onChange={(value) =>
            !line.id
              ? dispatch(
                  updateBundleValue('newBundle', {
                    ...newBundle,
                    comment: value,
                  })
                )
              : null
          }
        />
      </div>
    );
  };

  const {isBundleSheet, isConfiguredSheet, isModelingSheet, isModelingPhase, isModelingEstimate} = getSheetType(line);


  const handleExpandCard = (line: BundleLineDTO) => {
    setExpanded(true);
    const createProjectSheetsLines = (line) => line.ProjectSheets.map((sheet) => {
      const modeledProduct = modeledProductOptions.find((model) => model.id === sheet.SheetId);
      let sheetLine;
      if (modeledProduct) {
        sheetLine = {
          key: sheet.id,
          type_fiche: 'custom_user',
          quantity: sheet.quantity,
          SheetId: sheet.SheetId, //modeledProductId = modeledProduct.id
          AllotmentNodes: modeledProduct.AllotmentNodes,
          name: modeledProduct.name,
          unit: modeledProduct.unit,
          searchBarType: {
            bgColor:"#22A899",
            border:"none",
            color:"white",
            label:"Produits modélisés",
            value: SEARCH_GROUP_OPTION_VALUES.PRODUITS
          }
        }
      }
      if (isBundleSheet) {
        sheetLine = {
          ...sheet,
          key: sheet.id,
          caracs: {
            caracCombos: sheet.caracCombos,
            caracs: sheet.Caracs.map((carac) => ({
              ...carac,
              value: carac.SheetCarac?.value[0],
            })),
          },
        }
      }

      return sheetLine;
    });

    const createConfiguredSheetLines = (line) => line.ProjectSheet.map((sheet) => {
      const sheetLine = {
        ...sheet,
        AllotmentNodes: line.AllotmentNodes,
        fileName: '', 
        type_fiche: 'FC',
        key: sheet.id,
        caracs: {
          caracCombos: line.caracCombos,
          caracs: line.Caracs.map((carac) => ({
            ...carac,
            value: carac.SheetCarac?.value[0],
          })),
        },
      }

      return sheetLine;
    });

    const createModelingLines = (line) => ({
      key: line.id,
      modelingEquipmentCarbonWeightForm: {
        product: line.SheetIndex[0]?.AProd ?? null,
        installation: line.SheetIndex[0]?.AEdif ?? null,
        usage: line.SheetIndex[0]?.B ?? null,
        endOfLife: line.SheetIndex[0]?.C ?? null,
        profit: line.SheetIndex[0]?.D ?? null,
      },
    });

    const createModelingEstimateLines = (line) => ({
      key: line.id,
      manufacturedRate: line.SheetOption[0]?.manufacturedRate ?? null,
      materialLines: line.SheetOption[0]?.materialLines ?? [],
      totalWeight: line.SheetOption[0]?.totalWeight ?? null,
    });

    let newLines;
    if (line.type_fiche === 'bundle') {
      newLines = createProjectSheetsLines(line);
    } else if (isModelingPhase) {
      newLines = createModelingLines(line);
    } else if (isModelingEstimate) {
      newLines = createModelingEstimateLines(line);
    } else if (isConfiguredSheet) {
      newLines = createConfiguredSheetLines(line);
    }

    if (newLines) {
      dispatch(updateBundleValue('editBundle', [
        ...editBundle,
        { ...line, lines: Array.isArray(newLines) ? newLines : [newLines] },
      ]));
    }
  };

  const handleDuplicateCard = async () => {
    let body = {
      folderSheetId: folderSheetId,
      CompanyId: companyId,
      comment: line.comment,
    };

    const newNameAddOn = " - Copie";
    
    if (isBundleSheet) {
      body.User = line.User;
      body.name = line.name + newNameAddOn;
      body.unit = line.Unit.name;
      body.lines = line.ProjectSheets.map((el) => ({
        ...el,
        caracs: el.Caracs.map((car) => ({
          ...car,
          value: car.SheetCarac.value[0],
        })),
      }));
      body.typeOfSheet = "bundle";
    }

    if (isModelingSheet) {
      const unit = modeledProductOptions.find((model) => model.id === line.id)?.unit;
      body.typeOfSheet = "modeledProduct";
      body.type = "custom_user";
      body.caracteristic = {
        equipmentName: line?.name + newNameAddOn,
        labelQuote: "",
        lifeSpan: line.ddv,
        unit: line?.Unit?.name || unit,
      };
    }

    if (isModelingPhase) {
      body.isCarbonWeightSelected = true;
      body.materialComposition = { //TODO voir avec alex pour rendre cette clé optionnelle si pas de composition
        manufacturedRate: 25,
        totalWeight: null,
        materialLines: []
      };
      body.customACV = {
        AProd: line.SheetIndex[0].AProd,
        AEdif: line.SheetIndex[0].AEdif,
        B: line.SheetIndex[0].B,
        C: line.SheetIndex[0].C,
        D: line.SheetIndex[0].D,
      }
    }

    if (isModelingEstimate) {
      body.isCarbonWeightSelected = false;
      body.customACV = {};
      body.materialComposition = { //TODO voir avec alex pour rendre cette clé optionnelle si pas de composition
        manufacturedRate: line.SheetOption[0].manuefacturedRate,
        totalWeight: line.SheetOption[0].totalWeight,
        materialLines: line.SheetOption[0].materialLines
      };
    }

    if (isConfiguredSheet) {

      body.typeOfSheet = "FC";
      body.name = line.name + newNameAddOn;
      body.unit = line.Unit.name;
      
      const { xmlFileTextFormated } = await getXmlFileFromS3(folderSheetId, companyId, line.id);
      
      body.xml= xmlFileTextFormated; 
      body.fileName = line?.fileName; 
      const caracs = line.Caracs.map((carac) => ({
        ...carac,
        value: carac.SheetCarac.value[0],
      }));
      const AllotmentNodes = line.AllotmentNodes;

      body.form = {
        caracs,
        AllotmentNodes,
        fileName: line?.fileName,
      }
    };

    createBundleHook.mutate(body);
  };

  let userName = !line.id
    ? `${user.attributes.family_name} ${user.attributes.given_name}`
    : `${line?.User?.lastName} ${line?.User?.firstName}`;

  useEffect(() => {
    if (openModal) {
      setOpenModal(false);
    }
  }, [deleteBundleHook.isSuccess]);

  return (
    <>
      <ModalNooco
        title={t('APP.BUNDLECARDHEADER.INDEX.PH_5CCF53', {
          defaultValue: "Suppression de l'ensemble",
        })}
        isOpen={openModal}
        cancelFunction={() => setOpenModal(false)}
        validateFunction={() => deleteBundleHook.mutate(line)}
        closeOnOutsideClick={true}
        closeIcon={true}
        loading={deleteBundleHook.isLoading}
      >
        <div>
          {t('APP.BUNDLECARDHEADER.INDEX.PH_188A1C', {
            defaultValue:
              'Vous êtes sur le point de supprimer définitivement votre ensemble, voulez-vous continuer?',
          })}
        </div>
      </ModalNooco>
      <BundleCardWrapper
        onClick={(event) => {
          event.stopPropagation();
          if (!details && line.id) {
            handleExpandCard(line);
          }
        }}
        $screen={details ? 'details' : null}
        className="bundle-card"
      >
        {renderLineName()}
        {/* Emissions */}
        <div
          className="box-background"
          style={{ alignSelf: 'stretch', position: 'relative' }}
        >
          <p
            className="dark-blue-font"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {!line.id ? '0' : formatNumber(line.Emissions)} kg eq. CO₂
          </p>
          <Tooltip
            title={t('APP.BUNDLECARDHEADER.INDEX.PH_9EF5EB', {
              defaultValue:
                'L’impact affiché correspond à un calcul dynamique Nooco sur 50 ans',
            })}
          >
            <InfoIcon style={{ position: 'absolute', right: '-7px' }} />
          </Tooltip>
        </div>
        <div
          className="box-background"
          style={{ justifyContent: 'space-between', position: 'relative' }}
        >
          {/* box or modeling  */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {
              isBundleSheet && (
                <>
                  <Tooltip
                    title={t('APP.BUNDLECARDHEADER.INDEX.BUNDLE', {
                      defaultValue:
                        'Ensemble',
                    })}
                  >
                    <img src={macro} alt />
                  </Tooltip>
                  <p className="dark-blue-font" style={{ marginLeft: '1em' }}>
                    {line?.ProjectSheets?.length || 0} {t('APP.BUNDLE.BUNDLE_LIST.BUNDLE_CARD.BUNDLE_CARD_HEADER.INDEX.ELEMENTS', { defaultValue: 'éléments' })}
                  </p>
                </>
              )
            }
            {
              isConfiguredSheet && (
                <>
                  <Tooltip
                    title={t('APP.BUNDLE.BUNDLELIST.BUNDLECARD.BUNDLECARDHEADER.CONFIGURED_SHEET', {
                      defaultValue:
                        'Fiche configurée',
                    })}
                  >
                    <div style={{backgroundColor: "#e6a040", padding: "4px 8px", fontWeight: "bold", borderRadius: "4px", color: "white"}}>CONFIG</div>
                  </Tooltip>
                  <p className="dark-blue-font" style={{ marginLeft: '1em' }}>
                    {t('APP.BUNDLE.BUNDLELIST.BUNDLECARD.BUNDLECARDHEADER.CONFIGURED_SHEET', { defaultValue: 'Fiche configurée' })}
                  </p>
                </>
              )
            }
            {
              isModelingSheet && (
                <>
                  <Tooltip
                      title={t('APP.BUNDLECARDHEADER.INDEX.MODELED_PRODUCT', {
                        defaultValue:
                          'Produit modélisé',
                      })}
                    >
                      <img src={NoocoLogo}  />
                    </Tooltip>
                    <p className="dark-blue-font" style={{ marginLeft: '1em' }}>
                      {
                        isModelingPhase ? (
                          t('APP.BUNDLE.BUNDLE_LIST.BUNDLE_CARD.BUNDLE_CARD_HEADER.PHASE_TO_ENTER', {
                            defaultValue: 'Saisie par phase',
                          })
                        ) : (
                          t('APP.BUNDLE.BUNDLE_LIST.BUNDLE_CARD.BUNDLE_CARD_HEADER.ESTIMATE_COMPOSITION', {
                          defaultValue: 'Estimation composition',
                        })
                      )
                      }
                    </p>
                </>
              )
            }
          </div>
          {/* user && createDate */}
          <div>
          <p className="light-grey-font">
  {t('APP.BUNDLE.BUNDLE_LIST.BUNDLE_CARD.BUNDLE_CARD_HEADER.CREATOR', { defaultValue: 'Créateur :' })} {userName}
</p>
<p className="light-grey-font">
  {t('APP.BUNDLE.BUNDLE_LIST.BUNDLE_CARD.BUNDLE_CARD_HEADER.LAST_MODIFIED', { defaultValue: 'Dernière modification :' })}
  {!line.id && newBundle
    ? dayjs().format('L')
    : dayjs(line?.updatedAt).format('L')}
</p>
          </div>
          {/* Comment */}
          <Popover
            title={'Commentaire'}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            content={() => renderCommentInput()}
            trigger="click"
          >
            <Tooltip
              title={
                line.comment ||
                t('APP.BUNDLECARDHEADER.INDEX.PH_643A6C', {
                  defaultValue: 'Ajouter une description à l’ensemble',
                })
              }
              placement="top"
            >
              <div>
                <CommentIcon isCommentFilled={line.comment} />
              </div>
            </Tooltip>
          </Popover>
        </div>
        {/* delete and duplicate icon */}
        <div className="rounds-elements" style={{ marginLeft: 'auto' }}>
          <Tooltip
            title={t('APP.BUNDLECARDHEADER.INDEX.PH_7ABDBC', {
              defaultValue: "Dupliquer l'ensemble",
            })}
            placement="top"
          >
            <div>
              <RoundElement
                style={details ? styleNotAllowed : {}}
                type={'duplicate'}
                onClick={() => {
                  if (!details) {handleDuplicateCard();}
                }}
                bundle={true}
              />
            </div>
          </Tooltip>
          <Tooltip
            title={t('APP.BUNDLECARDHEADER.INDEX.PH_D030B8', {
              defaultValue: "Supprimer l'ensemble",
            })}
            placement="top"
          >
            <div>
              <RoundElement
                style={details ? styleNotAllowed : {}}
                type={'delete'}
                onClick={
                  details
                    ? () => {}
                    : () => {
                        setOpenModal(true);
                      }
                }
                bundle={true}
              />
            </div>
          </Tooltip>
        </div>
      </BundleCardWrapper>
    </>
  );
};

export default BundleCardHeader;
